/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResponse {
    getFixupPrototypeFunction() { return InventoryResponse.fixupPrototype; }

    static newInstance(model: Partial<InventoryResponse>): InventoryResponse {
        let obj = Object.assign(new InventoryResponse(), model);
        InventoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResponse>): InventoryResponse {
        if (!model) return null;
        return InventoryResponse.newInstance(<InventoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResponse) {
        if (!obj) return;

        models.InventoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResponse): boolean {
        Object.setPrototypeOf(obj, InventoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            for (let val of this.filters) {
                models.InventoryData.fixupPrototype(val);
            }
        }
    }

    /**
     * Filters available in inventory
     */
    filters: Array<models.InventoryData>;

}
